import { render } from "./Material.vue?vue&type=template&id=379ca82a&scoped=true"
import script from "./Material.vue?vue&type=script&lang=js"
export * from "./Material.vue?vue&type=script&lang=js"

import "./Material.vue?vue&type=style&index=0&id=379ca82a&lang=scss&scoped=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-379ca82a"]])

export default __exports__